import styled from 'styled-components';

const ListItem = styled.div`
  text-align: left;
  font-size: 16.67px;
`;

export default ListItem;
